import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';

import Authentication from '@/containers/Api/Authentication';
import Document from '@/containers/Api/Document';
import { useTranslation } from 'react-i18next';

function ApiContainer() {
  const navigate = useNavigate();
  const { hash } = useLocation();
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState();

  const items = [
    {
      label: t('api_page.authentication.authen'),
      key: '#authentication',
      children: <Authentication />,
    },
    {
      label: t('api_page.documents.tabs_title'),
      key: '#document',
      children: <Document />,
    },
  ];

  useEffect(() => {
    setActiveTab(hash || '#authentication');
  }, [hash]);

  const handleOnClickChangeTab = (key) => {
    setActiveTab(key);
    navigate(`${window.location.pathname}${key}`);
  };

  return (
    <div className="api-container">
      <Tabs
        items={items}
        activeKey={activeTab}
        onTabClick={handleOnClickChangeTab}
        destroyInactiveTabPane
      />
    </div>
  );
}

export default ApiContainer;
